import { ReactSDKClient } from '@optimizely/react-sdk';
import {
    createOptimizelyReactSDKClient,
    OptimizelyDataFile
} from './optimizely';

let optimizelyReactSDKClient: ReactSDKClient;

export const getOptimizelyReactSDKClient = (
    datafile: OptimizelyDataFile
): ReactSDKClient => {
    /**
     * Reuse the instance and take advantage of Next.js serialization.
     * Because we SSR we *must* use our own datafile. We cannot use the sdkKey
     * method to auto fetch the file for us.
     * https://github.com/optimizely/react-sdk#server-side-rendering
     */
    if (!optimizelyReactSDKClient) {
        optimizelyReactSDKClient = createOptimizelyReactSDKClient(datafile);
    }

    return optimizelyReactSDKClient;
};
